module.exports = __webpack_public_path__ + "static/media/jack_summit_intro_small_4.f0eefa2d.jpg";